(function () {
    "use strict";

    angular.module('app').component('listSelection', {
        templateUrl: '@/listSelection/listSelection.html',
        bindings: {
            linkDataSource: '=',
            linkObject: '=',
            linkFieldName: '@',
            linkCodeCountries: "="
        },
        controller: controller
    });


    controller.$inject = ['utils', '$scope'];
    function controller(utils, $scope) {
        const $ctrl = this;

        $scope.selectAll = false;
        $scope.data = [];
        $scope.fieldName = "";
        $scope.selectedCount = 0;
        $scope.codeCountries = [];

        $ctrl.$onChanges = function (changes) {
            if (changes) {
                $scope.data = angular.copy($ctrl.linkDataSource);
                $ctrl.linkObject = $ctrl.linkObject ? $ctrl.linkObject : [];
                $scope.fieldName = $ctrl.linkFieldName;
                $scope.codeCountries = angular.copy($ctrl.linkCodeCountries);

                $scope.selectCommonItems();
            }
        };

        $scope.selectAllItems = function (selectAll) {
            $scope.data.map(function (item) {
                item.active = !selectAll;
                return item;
            });

            $scope.getAllSelectedItems();
        };

        $scope.getAllSelectedItems = function () {
            const selectedItems = utils.getAllSelectedItems($scope.data);
            $ctrl.linkObject = angular.copy(selectedItems);
            $scope.selectedCount = $ctrl.linkObject.length;
        };

        $scope.isAllSelected = function () {
            if ($ctrl.linkObject.length > 0 && $ctrl.linkObject.length === $scope.data.length)
                $scope.selectAll = true;
            if ($ctrl.linkObject.length === 0)
                $scope.selectAll = false;
        };

        $scope.selectItem = function (item) {
            item.active = !item.active;

            $scope.getAllSelectedItems();
            $scope.isAllSelected();
        };

        $scope.selectCommonItems = function () {
            $scope.data.map(function (item) {
                item.BranchDropBoxName += " " + $scope.getLocalCountry(item.CodeCountry);

                if ($ctrl.linkObject && $ctrl.linkObject.filter(function (selected) {
                    return selected[$scope.fieldName] === item[$scope.fieldName];
                }).length > 0) {
                    item.active = true;
                    return item;
                }
            });

            $scope.isAllSelected();
            $scope.selectedCount = $ctrl.linkObject.length;
        };

        $scope.getLocalCountry = function (localCountryCode) {
            return $scope.codeCountries.filter(function (country) {
                return country.Key == localCountryCode;
            })[0].Value;
        };
    }
})();